import { render, staticRenderFns } from "./JobSingleView.vue?vue&type=template&id=6fa7c9de&scoped=true&"
import script from "./JobSingleView.vue?vue&type=script&setup=true&lang=js&"
export * from "./JobSingleView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./JobSingleView.vue?vue&type=style&index=0&id=6fa7c9de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa7c9de",
  null
  
)

export default component.exports